import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { heroContent, images } from '@/data/mock';

export const HeroSection = () => {
  const scrollToContent = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[var(--surface-cream)]">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-0 left-0 w-96 h-96 bg-[var(--color-gold-light)] rounded-full filter blur-3xl opacity-20 -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[var(--color-beige)] rounded-full filter blur-3xl opacity-40 translate-x-1/4 translate-y-1/4"></div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="text-center lg:text-left animate-fade-in">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/60 backdrop-blur-sm rounded-full mb-6">
              <span className="w-2 h-2 bg-[var(--color-gold)] rounded-full"></span>
              <span className="text-sm text-[var(--text-subtle)] font-medium">
                Élevage LOOF en Bretagne
              </span>
            </div>
            
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium text-[var(--text-primary)] leading-tight mb-6">
              {heroContent.title}
            </h1>
            
            <p className="text-lg sm:text-xl text-[var(--text-secondary)] leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              {heroContent.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link to="/maine-coon">
                <Button className="btn-primary w-full sm:w-auto">
                  Découvrir nos Maine Coons
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline" className="btn-outline w-full sm:w-auto">
                  Nous contacter
                </Button>
              </Link>
            </div>
          </div>

          {/* Image Grid */}
          <div className="relative animate-fade-in stagger-2">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="cat-card aspect-[3/4] overflow-hidden rounded-2xl">
                  <img
                    src={images.maineCoon1}
                    alt="Maine Coon"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="cat-card aspect-square overflow-hidden rounded-2xl">
                  <img
                    src={images.maineCoon2}
                    alt="Maine Coon"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="cat-card aspect-square overflow-hidden rounded-2xl">
                  <img
                    src={images.maineCoon3}
                    alt="Maine Coon"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="cat-card aspect-[3/4] overflow-hidden rounded-2xl">
                  <img
                    src={images.maineCoon4}
                    alt="Maine Coon"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
            
            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[var(--color-gold)] rounded-full opacity-20 blur-2xl"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-[var(--color-brown)] rounded-full opacity-10 blur-2xl"></div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollToContent}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-[var(--text-subtle)] hover:text-[var(--color-gold)] transition-colors cursor-pointer"
        aria-label="Défiler vers le bas"
      >
        <span className="text-xs uppercase tracking-wider">Découvrir</span>
        <ChevronDown className="w-5 h-5 animate-bounce" />
      </button>
    </section>
  );
};
